import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { ModalStyle } from 'src/admin-entity/interface/modal/modal-style.interface';

type ContextType = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    modalStyle: ModalStyle;
    setModalStyle: Dispatch<SetStateAction<ModalStyle>>;
    confirmButtonDisabled: boolean;
    setConfirmButtonDisabled?: Dispatch<SetStateAction<boolean>>;
};

const ModalContext = createContext(undefined);

export function ModalContextProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [modalStyle, setModalStyle] = useState<ModalStyle>(null);
    const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);

    return (
        <ModalContext.Provider
            value={{
                isOpen,
                setIsOpen,
                modalStyle,
                setModalStyle,
                confirmButtonDisabled,
                setConfirmButtonDisabled,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
}

export function useModalState(): ContextType {
    const state = useContext(ModalContext);
    if (!state) throw new Error('ModalProvider not found');
    return state;
}
